// mds-dojo — dijit/form/Button — FAITHFUL port of references/dijit/form/Button.js.
// Codemod pipeline; declare from the faithful runtime. Adaptations:
//  - `dojo/text!./templates/Button.html` → `import template from './templates/Button.html?raw'`
//    (template .html copied from references/dijit/form/templates/).
//  - dojo-bidi dropped: class name loses "_NoBidi" (always "dijit.form.Button"), the
//    trailing has("dojo-bidi") re-declare removed; unused `dojo/has` import dropped.
//  - the `dijit-legacy-requires` ready()/require() back-compat block + `require`,
//    `dojo/ready`, `dijit/a11yclick` imports removed (no AMD loader; ondijitclick is
//    mapped to "click" inside _AttachMixin).
//  - `kernel.deprecated` shimmed to no-op when the slim mds kernel lacks it.
// Basically the same thing as a normal HTML button, but with special styling.
import declare from '../../dojo/_base/declare-runtime'; // declare
import domClass from '../../dojo/dom-class'; // domClass.toggle
import kernel from '../../dojo/_base/kernel'; // kernel.deprecated
import lang from '../../dojo/_base/lang'; // lang.trim
import _FormWidget from './_FormWidget';
import _ButtonMixin from './_ButtonMixin';
import template from './templates/Button.html?raw';

var deprecated: any = (kernel as any).deprecated || function () { /* no-op shim */ };

export default declare("dijit.form.Button", [_FormWidget, _ButtonMixin], {
	// summary:
	//		Basically the same thing as a normal HTML button, but with special styling.
	// description:
	//		Buttons can display a label, an icon, or both.
	//		A label should always be specified (through innerHTML) or the label
	//		attribute.  It can be hidden via showLabel=false.

	// showLabel: Boolean
	//		Set this to true to hide the label text and display only the icon.
	showLabel: true,

	// iconClass: String
	//		Class to apply to DOMNode in button to make it display an icon
	iconClass: "dijitNoIcon",
	_setIconClassAttr: { node: "iconNode", type: "class" },

	baseClass: "dijitButton",

	templateString: template,

	// Map widget attributes to DOMNode attributes.
	_setValueAttr: "valueNode",
	_setNameAttr: function (name: any) {
		// avoid breaking existing subclasses where valueNode undefined.  Perhaps in 2.0 require it to be defined?
		if (this.valueNode) {
			this.valueNode.setAttribute("name", name);
		}
	},

	postCreate: function () {
		this.inherited(arguments);
		this._setLabelFromContainer();
	},

	_setLabelFromContainer: function () {
		if (this.containerNode && !this.label) {
			// When markup was set as srcNodeRef.innerHTML, copy it to this.label, in case someone tries to
			// reference that variable.
			this.label = lang.trim(this.containerNode.innerHTML);
			this.onLabelSet();		// set this.titleNode.title etc. according to label
		}
	},

	_setShowLabelAttr: function (val: any) {
		if (this.containerNode) {
			domClass.toggle(this.containerNode, "dijitDisplayNone", !val);
		}
		this._set("showLabel", val);
	},

	setLabel: function (/*String*/ content: any) {
		// summary:
		//		Deprecated.  Use set('label', ...) instead.
		deprecated("dijit.form.Button.setLabel() is deprecated.  Use set('label', ...) instead.", "", "2.0");
		this.set("label", content);
	},

	onLabelSet: function () {
		this.inherited(arguments);
		if (!this.showLabel && !("title" in this.params)) {
			this.titleNode.title = lang.trim(this.containerNode.innerText || this.containerNode.textContent || '');
		}
	}
});
